import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import s from "./ChangePasswordDialog.module.scss";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";

const DIALOG_LOCALE_KEY = "page.dialogs.";

const ChangePasswordDialog = ({ userId, updatePayload }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const [error, setError] = useState(false);

  const INPUT_FIELD_INIT_STATE = {
    id: userId,
    newPassword: "",
  };

  const [fieldInput, setFieldInput] = useState(INPUT_FIELD_INIT_STATE);

  const passwordIsStrong = (password) => {
    return password.length >= 8
  };

  const passwordInputOnChange = (e, field) => {
    const { value } = e.target;
    setError(false);
    setFieldInput({ ...fieldInput, [field]: value });
    if (passwordIsStrong(value)) {
      updatePayload({ ...fieldInput, [field]: value });
    } else {
      updatePayload({ ...fieldInput, [field]: "" });
    }
  };

  const textInputOnFocus = (field) => {
    setFocus({ [field]: true });
  };

  const textInputOnBlur = (field, callback) => {
    if (fieldInput[field] && callback) {
      const isValidValue = callback(fieldInput[field]);
      if (!isValidValue) {
        setError(true);
      }
    }
    setFocus({ [field]: false });
  };

  return (
    <div className={s.contentContainer}>
      <OutlinedText
        label={t(DIALOG_LOCALE_KEY + "changePassword.newPassword.label")}
        placeholder={t(
          DIALOG_LOCALE_KEY + "changePassword.newPassword.placeholder",
        )}
        value={fieldInput.newPassword}
        onchangeFn={(e) => passwordInputOnChange(e, "newPassword")}
        onfocusFn={() => textInputOnFocus("newPassword")}
        onblurFn={() => textInputOnBlur("newPassword", passwordIsStrong)}
        sxParams={{
          textFocus: focus.newPassword,
          textError: error,
        }}
        errorMessage={t(
          DIALOG_LOCALE_KEY + "changePassword.newPassword.errorInput",
        )}
      />
    </div>
  );
};

export default ChangePasswordDialog;
